import type { LogicGroup } from '@/types/logic';
import { EligibilityLogicGroupPayload } from '@/types/treatmentGroup';

const isEmptyEligibilityValue = (value: unknown): boolean =>
  value == null || value === '' || (Array.isArray(value) && value.length === 0);

// Serialize a logic tree into the write payload: drop the temp ids/subject_id
// (assigned server-side), prune conditions with no value, and drop groups
// that end up empty so we never persist no-op scaffolding. Shared between
// TreatmentGroupForm (the in-progress builder tree) and any read-only
// consumer that needs to re-check eligibility against a saved group's tree
// (e.g. TreatmentGroupView's member badges).
export const toEligibilityPayload = (groups: LogicGroup[]): EligibilityLogicGroupPayload[] =>
  groups
    .map((group) => ({
      logic_operator: group.logic_operator,
      logic_elements: group.logic_elements
        .filter((element) => !isEmptyEligibilityValue(element.value))
        .map((element) => ({
          comparison_operator: element.comparison_operator,
          field: element.field,
          is_negated: element.is_negated,
          value: element.value
        })),
      logic_groups: toEligibilityPayload(group.logic_groups)
    }))
    .filter((group) => group.logic_elements.length > 0 || group.logic_groups.length > 0);
